module.exports = __webpack_public_path__ + "img/smartmatic-logo@3x.f3498ca8.png";